.container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  border-width: 1px;
  border-radius: 16px;
  padding: 12px 16px;
}

.green {
  border-color: var(--color-border-green-tertiary);
  background-color: var(--color-surface-green-tertiary);
}

.yellow {
  border-color: var(--color-border-orange-tertiary);;
  background-color: var(--color-surface-orange-tertiary);
}

.red {
  border-color: var(--color-border-red-tertiary);
  background-color: var(--color-surface-red-tertiary);
}

.wait {
  border-color: var(--color-border-blue-tertiary);
  background-color: var(--color-surface-blue-tertiary);
}
